import { Injectable } from '@angular/core'
import { CanActivate, Router } from '@angular/router'
import { map, catchError } from 'rxjs/operators'
import { of, from } from 'rxjs'
import { fetchUserAttributes } from 'aws-amplify/auth'
import { ErrorHandlerService } from '../services/utils/error-handler.service'

@Injectable({
  providedIn: 'root',
})
export class VerifyPhoneGuard implements CanActivate {
  constructor(
    private router: Router,
    private errorHandler: ErrorHandlerService
  ) {}

  canActivate() {
    return from(fetchUserAttributes()).pipe(
      map((attributes) => {
        if (
          attributes.phone_number &&
          attributes.phone_number_verified === 'true'
        ) {
          this.router.navigate(['/map'])
          return false
        }
        return true
      }),
      catchError((error) => {
        this.errorHandler.handleError(error)
        return of(true)
      })
    )
  }
}
